import React from 'react';
import '../index.scss';

const optionsDate = {
    weekday: "long",
    year: "numeric",
    month:"long",
    day:"numeric"}

const optionsTime = {
    localeMatcher: "best fit", 
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
     }

const localesTime = {
    
}

class Clock extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            time: new Date()
        };
    }

    componentDidMount() {
        this.timerID = setInterval(
            () => this.tick(),
            1000
        );
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
    }

    tick() {
        this.setState({
            time: new Date()

        });
    }

    render() {
        return (
            <div>
               <p><span className='naviLinksDT'>Date: </span><span className='paddingNavbar'>{this.state.date.toLocaleDateString("en-GB", optionsDate)}</span><br/><span className='naviLinksDT'>Time: </span>{this.state.time.toLocaleTimeString(optionsTime)} (<span className='naviLinksDT'>United Kingdom</span>)</p>
            </div>
        );
    } 

}

export default Clock;
